import { createSelector } from 'reselect';
import { calculateTotal } from '../utils/lineItemUtils';

const getPhaseLineItemsSelector = state => state.phase.phaseLineItems.items;

export const getPhaseLineItemsWithTotal =
  createSelector(
    getPhaseLineItemsSelector,
    items =>
      items.map((item) => {
        const itemWithTotal = item;
        itemWithTotal.calculatedTotal = calculateTotal(item.price, item.quantity);
        return itemWithTotal;
      }),
  );

export const getPricePatchItems = state => state.pricePatchLineItems.data;



// WEBPACK FOOTER //
// ./client/app/selectors/phaseLineItem.js